import { Injectable, Inject } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Sgkc009aRequest, Sgkc009aResponse, SGKC009AService } from 'sg-api';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

/**
 * 単価表取消API使用サービス
 * @export
 * @class UsedSgkc009aService
 */
@Injectable({
    providedIn: 'root'
})
export class UsedSgkc009aService {
    /**
       * コンストラクタ
       * @param {SGKC009AService} sGKC009AService
       * @param {ApiCommonService} apiCommonService
       * @param {FeaturesLibConfig} featuresLibConfig
       * @memberof UsedSgkc009aService
       */
    constructor(private sGKC009AService: SGKC009AService,
        private apiCommonService: ApiCommonService,
        @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

    /**
     * 単価表取消API呼び出し
     * @param {Sgkc009aRequest} sgkc009aRequest
     * @return {Observable<Sgkc009aResponse>}
     * @memberof UsedSgkc009aService
     */
    deleteTankatable(sgkc009aRequest: Sgkc009aRequest): Observable<Sgkc009aResponse> {
        return this.sGKC009AService.kC10WSGKC009APost(<Sgkc009aRequest>this.apiCommonService.setRequestCommon(sgkc009aRequest), 'response')
            .pipe(
                map(response => {
                    // エラーが設定されていないかチェックする
                    this.apiCommonService.checkError(response);
                    return response.body;
                }),
                timeout(Number(this.featuresLibConfig.httpTimeout)),
                catchError((err) => {
                    this.apiCommonService.dispErrorMessage(err, 'sgkc', 'SGKC009A');
                    return throwError(err.message);
                })
            );
    }

}
